export default __webpack_public_path__ + "static/media/Smartle6.11d35dd6.png";